export const HERO_STARS = [
  {
    position: 'first',
    reverse: false
  },
  {
    position: 'second',
    reverse: true
  },
  {
    position: 'third',
    reverse: false
  },
  {
    position: 'fourth',
    reverse: true
  },
  {
    position: 'fifth',
    reverse: false
  },
  {
    position: 'sixth',
    reverse: true
  },
  {
    position: 'seventh',
    reverse: false
  },
  {
    position: 'eighth',
    reverse: true
  }
]

export const CARD_STARS = [
  {
    position: 'first',
    reverse: false
  },
  {
    position: 'second',
    reverse: true
  },
  {
    position: 'third',
    reverse: true
  },
  {
    position: 'fourth',
    reverse: false
  },
  {
    position: 'fifth',
    reverse: false
  },
  {
    position: 'sixth',
    reverse: true
  }
]
